import { Grid, CardContent } from "@mui/material";
import { IFlightPairingDetails, IFullFlight } from "@vmosolutions/oc-interfaces";

import { FormHeader } from "../helpers";
import { DisplayCrewRidersOnFlight } from "src/pages/CrewRidersOnFlight/DisplayCrewRidersOnFlight";

interface ICrewTabProps {
  fullFlight?: IFullFlight; // Id of the flight to retrieve and edit if provided.
  updateTabState?: (dirtyStatus: boolean) => void; // update parent with dirty status.
  mosaicId: string;
  setAPICallStatus?: (statusMessage: string) => void;
  isAPISCustomer?: boolean;
  crewOnFlight: Record<string, IFlightPairingDetails[]>;
  setLoadedFlight?: (flightValues: IFullFlight) => void;
}

/**
 * Flight Crew/Riders Tab
 * @param props -
 */
export const CrewTab = (props: ICrewTabProps): JSX.Element => {
  const { fullFlight, updateTabState, mosaicId, setAPICallStatus, isAPISCustomer, crewOnFlight, setLoadedFlight } =
    props;

  return (
    <CardContent id={`${mosaicId}-crew-editor`} className="form_card crew">
      <Grid container direction="column">
        <FormHeader title={isAPISCustomer ? "Crew / Riders" : "Crew"} subtitle="" />
        {fullFlight ? (
          <DisplayCrewRidersOnFlight
            windowId={mosaicId}
            flight={fullFlight}
            isAPISCustomer={isAPISCustomer}
            updateTabState={updateTabState}
            crewOnFlight={crewOnFlight}
            setLoadedFlight={setLoadedFlight}
          />
        ) : (
          <DisplayCrewRidersOnFlight windowId={mosaicId} isAPISCustomer={false} crewOnFlight={crewOnFlight} />
        )}
      </Grid>
    </CardContent>
  );
};
